import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import { option_category_obj } from "../../../service/option";

export default function MemberSettingManual() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關", href: "/member/setting" },
    { key: 3, label: option_category_obj.setting.manual.label },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: option_category_obj.setting.manual.label }} />

      <iframe
        className="w-full h-40rem md:h-50rem mt-3 mb-4"
        src="https://drive.google.com/file/d/1VyKJcc3DQfLfwy03ylpI2IO7luYIk38v/preview"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
      ></iframe>
    </>
  );
}
